import React, {useContext, useEffect, useState} from 'react';
import {Grid, TextField} from "@mui/material";
import {blueColor, red500} from "../../../../assets/jss/main";
import {FormattedMessage} from 'react-intl';

import SelectTitle from "../../../../components/radioGroup/SelectTitle";
import {getPriorityRulesForForm, wmsPriorityRule} from "../../../../utils/wmsPriorityRule";
import FormControlLabel from "../../../../components/radioGroup/FormControlLabel";
import RadioGroup from "../../../../components/radioGroup/RadioGroup";
import FormToggleSelection from "./FormToggleSelection";
import DesktopProviderDrawer from "../Desktop/DesktopProviderDrawer";
import MobileProviderDrawer from "../Mobile/MobileProviderDrawer";
import RunnerSelect from "./RunnerSelect";
import InputTextField from "../../../../components/input/new/InputTextField";
import CustomButton from "../../../../components/CustomButton";
import {createNewMission} from "../../../../api/wms/tasks/new";
import {WMSContext} from "../../context/WMSContext";
import {createNewModel} from "../../../../api/wms/wmsTaskModel/new";
import Toast from "../../../../components/WMS/Toast";
import ValidatedIcon from "../../../../assets/img/validated.svg";
import ErrorIcon from "../../../../assets/img/error.svg";
import Label from "../../../../components/input/new/Label";
import {PickingMissionModelContext} from "../PickingMissionModelContext";
import {PickingMissionModelAgeInDays} from "./PickingMissionModelAgeInDays";
import update from "api/wms/wmsTaskModel/update"
import {WMSRoutes} from "../../../../utils/WMSRoutes";
import {useHistory} from "react-router-dom";
import moment from "moment/moment";

const desktopMaxWidth = "45%"

function CreatePickingMissionForm() {
    const {
        data: formData,
        editableModel,
        isEdit,
        isModel,
        isModelAuto,
        isMobile,
        init: handleResetForm
    } = useContext(PickingMissionModelContext)


    const {currentInventory} = useContext(WMSContext)

    const [missionName, setMissionName] = useState("")
    const [priorityRules, setPriorityRules] = useState([])
    const [selectedPriorityRule, setSelectedPriorityRule] = useState([])
    const [places, setPlaces] = useState()
    const [orderTypes, setOrderTypes] = useState()
    const [ages, setAges] = useState()
    const [shippingMethods, setShippingMethods] = useState()
    const [providers, setProviders] = useState()
    const [selectedProviders, setSelectedProviders] = useState([])
    const [quantity, setQuantity] = useState(10)
    const [runners, setRunners] = useState()
    const [selectedRunners, setSelectedRunners] = useState([])
    const [productCount, setProductCount] = useState(0)
    const [selectedItems, setSelectedItems] = useState([])
    const [isValid, setIsValid] = useState(false)
    const [openToast, setOpenToast] = useState(false)
    const [openErrorToast, setOpenErrorToast] = useState(false)
    const [numberProductError, setNumberProductError] = useState(false)

    const [openProviderDrawer, setOpenProviderDrawer] = useState(false)

    const [loading, setLoading] = useState(false);

    const history = useHistory();


    const handleChangeMissionName = (value) => {
        setMissionName(value)
    }

    const handleSelectPriorityRules = (rule) => {
        setSelectedPriorityRule(priorityRules.find(priorityRule => priorityRule.value === rule))
    }

    const handleSelectRunners = (runner) => {
        // This version is for multi select runner but there might be a issue with the ways the WmsTask
        // work with multiple runners so its disabled for now.

        // let tempData = [...selectedRunners]
        // let updatedRunnerList = {...runners}

        // if (!selectedRunners.some(r => r.id === runner.id)) {
        //     tempData.push(runner)
        //     updatedRunnerList[runner.id]["selected"] = true
        // } else {
        //    tempData = tempData.filter(r => r.id !== runner.id)
        //     updatedRunnerList[runner.id]["selected"] = false
        // }
        // setRunners(updatedRunnerList)
        // setSelectedRunners(tempData)

        // This version is for a mono select runner
        let updatedRunnerList = {...runners}
        const runnerListKeys = Object.keys(updatedRunnerList)

        if (runner === selectedRunners) {
            updatedRunnerList[runner.id]["selected"] = false
            setSelectedRunners([])
        } else {
            runnerListKeys.map(runnerId => {
                updatedRunnerList[runnerId]["selected"] = runnerId === runner.id;
            })
            setSelectedRunners(runner)
        }

        setRunners(updatedRunnerList)
    }

    const handleSelectPlace = (place) => {
        const placeId = place.id

        setPlaces({
            ...places,
            [placeId]: {
                ...places[placeId],
                selected: !places[placeId].selected
            }
        })
    }

    const handleSelectOrderType = (orderType) => {
        const orderTypeValue = orderType.value

        setOrderTypes({
            ...orderTypes,
            [orderTypeValue]: {
                ...orderTypes[orderTypeValue],
                selected: !orderTypes[orderTypeValue].selected
            }
        })
    }

    const handleSelectAge = (age) => {
        const ageValue = age.value

        setAges({
            ...ages,
            [ageValue]: {
                ...ages[ageValue],
                selected: !ages[ageValue].selected
            }
        })
    }

    const handleSelectShippingMethods = (shippingMethod) => {
        const shippingMethodId = shippingMethod.id

        setShippingMethods({
            ...shippingMethods,
            [shippingMethodId]: {
                ...shippingMethods[shippingMethodId],
                selected: !shippingMethods[shippingMethodId].selected
            }
        })
    }

    const handleSelectProvider = (provider) => {
        const providerId = provider.id

        if (!selectedProviders[providerId]) {
            let newProvider = providers[providerId]
            newProvider.selected = true

            let alreadySelectedProviders = {...selectedProviders}
            alreadySelectedProviders["all"].selected = false
            alreadySelectedProviders[providerId] = {...newProvider}
            setSelectedProviders(alreadySelectedProviders)

            let updatedProviders = {...providers}
            updatedProviders[providerId].selected = true
        } else {
            handleDeselectProvider(providerId)
        }

    }

    const handleOpenProviderDrawer = () => {
        setOpenProviderDrawer(true)
    }
    const handleCloseProviderDrawer = () => {
        setOpenProviderDrawer(false)
    }

    const handleDeselectProvider = (providerId) => {
        if (typeof providerId === "object") {
            providerId = providerId.id
        }
        if (providerId !== "all") {
            let updatedSelectedProviders = {...selectedProviders}
            delete updatedSelectedProviders[providerId]

            if (Object.keys(updatedSelectedProviders).length === 1) {
                updatedSelectedProviders["all"].selected = true
            }
            setSelectedProviders(updatedSelectedProviders)

            let updatedProviders = {...providers}
            updatedProviders[providerId].selected = false
        } else {
            // Reset providers to prevent visual bug inside the Provider drawer
            let tempProviders = {...providers}
            Object.keys(tempProviders).map(tempProviderId => {
                if ("all" !== tempProviderId) {
                    tempProviders[tempProviderId].selected = false
                }
            })

            setProviders(tempProviders)

            // Reset selectedProviders to only include "all", keeping its existing data but ensuring it is selected.
            setSelectedProviders({
                all: {
                    ...selectedProviders.all,
                    selected: true
                }
            })
        }
    }

    const getObjectData = (data) => {
        const dataKeys = Object.keys(data)
        let tempData = []
        dataKeys.map((k) => {
            tempData.push(data[k])
        })

        return tempData
    }

    const filterItem = (array1, array2) => {
        return array1.filter(item => array2.includes(item));
    }

    const orderByItemsCount = (data, count) => {
        return data.slice().sort((a, b) => {
            if (a[count] === 0 && b[count] !== 0) return 1;
            if (a[count] !== 0 && b[count] === 0) return -1;
            return b[count] - a[count];
        });
    }

    const getInitProvider = () => {
        let initToggle = {}
        let formDataProviders = formData.providers

        initToggle["all"] = formDataProviders["all"]
        initToggle["all"].name = <FormattedMessage id={"wms.newPickingMission.allProviderToggle.name"}/>

        if (isEdit) {
            let editableModelProvider = formData.isRetailerPriority ? editableModel.retailers : editableModel.brands

            if (0 < editableModelProvider.length) {
                Object.keys(formDataProviders).map(providerId => {
                    if (editableModelProvider.some(pvd => pvd.id === providerId)) {
                        formDataProviders[providerId].selected = true
                        initToggle[providerId] = formDataProviders[providerId]
                    }
                })
            }

            if (1 < Object.keys(initToggle).length) {
                initToggle["all"].selected = false
            }
        }
        return initToggle
    }

    function formatNoWmsPlaces(wmsPlaces) {
        return {
            ...wmsPlaces,
            noWmsPlaces: {
                ...wmsPlaces.noWmsPlaces,
                name: <FormattedMessage id={"wms.newPickingMission.noWmsPlacesToggle.name"} />,
                selected: false
            }
        };
    }

    const handleChangeQuantity = (value) => {
        if (value === '') {
            setQuantity(0);
            setNumberProductError(false);
            return;
        }

        if (/^\d+$/.test(value)) {
            const numericQuantity = Number(value);
            setQuantity(numericQuantity);
            setNumberProductError(false);
        } else {
            setNumberProductError(true);
        }
    }

    const handleValid = () => {
        setLoading(true);
            if (isEdit) {
                let data = {
                    name: missionName,
                    auto: isModelAuto,
                    inventory: currentInventory["@id"],
                    maxItems: quantity,
                    priorityOrder: selectedPriorityRule.value,
                    noWmsPlaces: Object.keys(places).some(placeId => placeId === "noWmsPlaces" && true === places[placeId].selected),
                    wmsPlaces: Object.keys(places).filter(placeId => "noWmsPlaces" !== placeId && places[placeId].selected).map(id => `/w_m_s_places/${places[id].barcode}`),
                    shippingMethods: Object.keys(shippingMethods).filter(shippingMethodId => true === shippingMethods[shippingMethodId].selected).map(id => `/shipping_methods/${shippingMethods[id].id}`),
                    isMulti: null,
                    ageInDays: null,
                    retailers: [],
                    brands: [],
                    updatedAt: moment()
                }

                const filteredProviders = Object.keys(providers).filter(providerId => true === providers[providerId].selected)

                if (!filteredProviders.some(providerId => "all" === providerId)) {
                    if (true === formData.isRetailerPriority) {
                        data.retailers = filteredProviders.map(id => `/retailers/${providers[id].id}`)
                    } else {
                        data.brands = filteredProviders.map(id => `/brands/${providers[id].id}`)
                    }
                }

                data.ageInDays = Object.keys(ages).map(ageId => {
                    if (ages[ageId].selected) {
                        switch (ageId) {
                            case "j-0":
                                return 0;
                            case "j-1":
                                return 1;
                            case "j-2":
                                return 2;
                            case "j-3":
                                return 3;
                            default:
                                return 4;
                        }
                    }
                }).filter(age => undefined !== age && null !== age)

                let orderTypeArray = Object.keys(orderTypes).filter(type => true === orderTypes[type].selected)

                if(1 === orderTypeArray.length) {
                    if ("multi" === orderTypeArray[0]) {
                        data.isMulti = true
                    } else {
                        data.isMulti = false
                    }
                }

                update(editableModel, data).then((response) => {
                    history.push({
                        pathname: WMSRoutes.MISSION_MODEL_LIST,
                        state: { hasChanged: response.name },
                        action: "PUSH"
                    })
                }).catch(() => {
                    setOpenErrorToast(true)
                }).finally(() => setLoading(false))
                return;
            }

        if (isModel) {
            const data = {
                auto: isModelAuto,
                name: missionName,
                inventory: currentInventory,
                places: places,
                orderTypes: orderTypes,
                providers: selectedProviders,
                quantity: quantity,
                shippingMethods: shippingMethods,
                priorityRules: selectedPriorityRule,
                age: ages
            }

            createNewModel(data).then(() => {
                handleResetForm()
                setMissionName("")
                setOpenToast(true)
            }).catch(() => {
                setOpenErrorToast(true)
            }).finally(() => setLoading(false))
        } else {
            const data = {
                name: missionName,
                inventory: currentInventory,
                places: places,
                providers: selectedProviders,
                runner: selectedRunners,
                quantity: quantity,
                items: selectedItems,
                priorityRules: selectedPriorityRule["value"]
            }

            createNewMission(data).then(() => {
                handleResetForm()
                setMissionName("")
                setOpenToast(true)
            }).catch(() => {
                setOpenErrorToast(true)
            }).finally(() => {
                setLoading(false)
            })
        }
    }

    useEffect(() => {
        let totalItems = formData.allItems
        setIsValid(false)

        if (places) {
            let tempPlaces = getObjectData(places)
            if (priorityRules.value === wmsPriorityRule.PLACE_ITEMS) {
                tempPlaces = orderByItemsCount(tempPlaces, "count")
            }
            let tempSelectedPlacesItem = []
            tempPlaces.map(place => {
                if (place.selected) {
                    setIsValid(true)
                    place.items.map(item => {
                        if (!tempSelectedPlacesItem.includes(item)) {
                            tempSelectedPlacesItem.push(item)
                        }
                    })
                }
            })
            if (tempSelectedPlacesItem.length > 0) {
                totalItems = filterItem(totalItems, tempSelectedPlacesItem)
            }
        }

        if (selectedProviders) {
            let tempProviders = getObjectData(selectedProviders)
            if (priorityRules.value === wmsPriorityRule.RETAILER_ITEMS) {
                tempProviders = orderByItemsCount(tempProviders, "count")
            }
            let tempProvidersItem = []
            tempProviders.map(provider => {
                if (provider.selected) {
                    if (provider.items.length > 0) {
                        setIsValid(true)
                    }
                    provider.items.map(item => {
                        if (!tempProvidersItem.includes(item)) {
                            tempProvidersItem.push(item)
                        }
                    })
                }
            })
            if (tempProvidersItem.length > 0) {
                totalItems = filterItem(totalItems, tempProvidersItem)
            }
        }

        if (orderTypes) {
            const tempOrderTypes = getObjectData(orderTypes)
            let tempSelectedOrderTypesItem = []
            tempOrderTypes.map(orderType => {
                if (orderType.selected) {
                    setIsValid(true)
                    orderType.items.map(item => {
                        if (!tempSelectedOrderTypesItem.includes(item)) {
                            tempSelectedOrderTypesItem.push(item)
                        }
                    })
                }
            })
            if (tempSelectedOrderTypesItem.length > 0) {
                totalItems = filterItem(totalItems, tempSelectedOrderTypesItem)
            }
        }

        if (shippingMethods) {
            const tempShippingMethods = getObjectData(shippingMethods)
            let tempSelectedShippingMethodsItems = []
            tempShippingMethods.map(shippingMethod => {
                if (shippingMethod.selected) {
                    setIsValid(true)
                    shippingMethod.items.map(item => {
                        if (!tempSelectedShippingMethodsItems.includes(item)) {
                            tempSelectedShippingMethodsItems.push(item)
                        }
                    })
                }
            })
            if (tempSelectedShippingMethodsItems.length > 0) {
                totalItems = filterItem(totalItems, tempSelectedShippingMethodsItems)
            }
        }

        if (ages) {
            const tempAges = getObjectData(ages)
            let tempAgesItems = []
            tempAges.map(age => {
                if (age.selected) {
                    setIsValid(true)
                    age.items.map(item => {
                        if (!tempAgesItems.includes(item)) {
                            tempAgesItems.push(item)
                        }
                    })
                }
            })
            if (tempAgesItems.length > 0) {
                totalItems = filterItem(totalItems, tempAgesItems)
            }
        }


        if (totalItems.length > quantity) {
            setProductCount(quantity)
            if (priorityRules.value === wmsPriorityRule.PLACE_ITEMS) {
                const tempPlaces = getObjectData(places)
                let maxItemPlace = {count: 0}
                tempPlaces.map(place => {
                    if (place.count > maxItemPlace.count) {
                        maxItemPlace = place
                    }
                })
                totalItems = totalItems.filter
            }

            if (priorityRules.value === wmsPriorityRule.RETAILER_ITEMS) {

            }
            totalItems = totalItems.slice(0, quantity)
        }
        if (missionName.length < 1) {
            setIsValid(false)
        }

        if (!isModel && selectedRunners.length < 1) {
            setIsValid(false)
        }

        if (!/^\d+$/.test(quantity)) {
            setIsValid(false)
        }

        setProductCount(totalItems.length)
        setSelectedItems(totalItems)
    }, [selectedPriorityRule, selectedRunners, selectedProviders, places, orderTypes, ages, shippingMethods, quantity, missionName]);

    useEffect(() => {
        let places = formatNoWmsPlaces(formData.places)
        let orderType = formData.orderType
        let shippingMethods = formData.shippingMethods
        let priorityRules = getPriorityRulesForForm()
        let selectedPriorityRule = priorityRules.find(rule => rule.value === wmsPriorityRule.FIFO)
        let ages = formData.age

        setRunners(formData.members)

        if (isEdit && editableModel) {
            setMissionName(editableModel.name)

            selectedPriorityRule = priorityRules.find(rule => rule.value === editableModel.priorityOrder)
            if (0 < editableModel.wmsPlaces.length) {
                Object.keys(places).map(placeId => {
                    if (editableModel.wmsPlaces.some(plc => plc.id === placeId)) {
                        places[placeId].selected = true
                    }
                })
            }

            if (editableModel.noWmsPlaces) {
                places.noWmsPlaces.selected = true
            }

            if (undefined !== editableModel.isMulti && null !== editableModel.isMulti) {
                if (true === editableModel.isMulti) {
                    orderType.multi.selected = true
                } else if(false === editableModel.isMulti) {
                    orderType.mono.selected = true
                }
            }

            if (0 < editableModel.shippingMethods.length) {
                Object.keys(shippingMethods).map(shippingMethodId => {
                    if (editableModel.shippingMethods.some(method => method.id === shippingMethodId)) {
                        shippingMethods[shippingMethodId].selected = true
                    }
                })
            }

            if (0 < editableModel.ageInDays.length) {
                editableModel.ageInDays.forEach(ageInDay => {
                    if (Object.keys(ages).some(ageValue => ageValue === PickingMissionModelAgeInDays[ageInDay])) {
                        ages[PickingMissionModelAgeInDays[ageInDay]].selected = true
                    }

                })
            }

            setQuantity(editableModel.maxItems)
        }

        let initToggle = getInitProvider()
        setSelectedProviders(initToggle)

        setProviders(formData.providers)

        setAges(ages)
        setPlaces(places)
        setOrderTypes(orderType)
        setShippingMethods(shippingMethods)
        setSelectedPriorityRule(selectedPriorityRule)
        setPriorityRules(getPriorityRulesForForm())
    }, [formData, isModel, isEdit, editableModel]);

    return (
        <Grid container direction={"column"} gap={"48px"}>
            <Grid container direction={"column"} gap={"32px"}>
                {openToast && (
                    <Toast
                        open={openToast}
                        handleClose={() => setOpenToast(false)}
                        isDesktop={!isMobile}
                        isTop={!isMobile}
                        customTimeout={2000}
                        icon={<img style={{height: '20px', width: '20px'}} src={ValidatedIcon} alt={"validated-icon"}/>}
                        title={<FormattedMessage id={"wms.newPickingMission.successToast.title"}/>}
                    />
                )}

                {openErrorToast && (
                    <Toast
                        open={openErrorToast}
                        handleClose={() => setOpenErrorToast(false)}
                        isDesktop={!isMobile}
                        isTop={!isMobile}
                        customTimeout={2000}
                        icon={<img style={{height: '20px', width: '20px'}} src={ErrorIcon} alt={"error-icon"}/>}
                        title={<FormattedMessage id={"wms.newPickingMission.errorToast.title"}/>}
                    />
                )}
                <span
                    style={{
                        fontSize: "20px",
                        color: blueColor,
                        fontWeight: 600
                    }}
                >
                    {isModel && (
                        <FormattedMessage id={"wms.newPickingMissionModel.name.title"}/>
                    )}
                    {false === isModel && (
                        <FormattedMessage id={"wms.newPickingMission.name.title"}/>
                    )}
                </span>
                <Grid
                    container
                    direction={"column"}
                    gap={"8px"}
                    sx={{
                        width: "100%",
                        maxWidth: isMobile ? 'none' : desktopMaxWidth
                    }}
                >
                    <Label htmlFor={`name`} required={true}>
                        {isModel ? (
                            <FormattedMessage id={"wms.newPickingMissionModel.name.title"}/>
                        ) : (
                            <FormattedMessage id={"wms.newPickingMission.name.title"}/>
                        )}
                    </Label>
                    <InputTextField
                        value={missionName}
                        placeholder
                        onChange={(event) => handleChangeMissionName(event.target.value)}
                    />
                </Grid>
            </Grid>

            <Grid container direction={"column"} gap={"32px"}>
                <span
                    style={{
                        fontSize: "20px",
                        color: blueColor,
                        fontWeight: 600
                }}
                >
                    <FormattedMessage id={"wms.newPickingMission.priorityRules.title"}/>
                </span>

                <Grid
                    container
                    direction={"column"}
                    sx={{width:"100%", maxWidth: isMobile ? 'none' : desktopMaxWidth}}
                >
                    <SelectTitle titleTranslationKey={"wms.newPickingMission.priorityRules.label"}/>
                    <RadioGroup
                        alignListWithButton
                        selectedValueLabel={selectedPriorityRule?.label}
                        value={selectedPriorityRule?.value}
                        onChange={(event) => {
                            handleSelectPriorityRules(event.currentTarget.value)
                        }}
                    >
                        {priorityRules.map((rule, index) => (
                            <FormControlLabel
                                key={index}
                                value={rule.value}
                                label={rule.label}
                            />
                        ))}
                    </RadioGroup>
                </Grid>

                <Grid container direction={"column"} gap={"24px"}>
                    <span
                        style={{
                            fontSize: "20px",
                            color: blueColor,
                            fontWeight: 600,
                            marginBottom: "8px"
                        }}
                    >
                        <FormattedMessage id={"wms.newPickingMission.pickingChoice.title"}/>
                    </span>

                    {places && (
                        <FormToggleSelection
                            data={places}
                            title={<FormattedMessage id={"wms.newPickingMission.placeChoice"}/>}
                            identity={"name"}
                            count={"count"}
                            handleSelectValue={handleSelectPlace}
                            isModel={isModel}
                            getObjectData={getObjectData}
                            orderByItemsCount={orderByItemsCount}
                        />
                    )}

                    {orderTypes && (
                        <FormToggleSelection
                            data={orderTypes}
                            title={<FormattedMessage id={"wms.newPickingMission.orderTypes"}/>}
                            identity={"name"}
                            count={"count"}
                            handleSelectValue={handleSelectOrderType}
                            isModel={isModel}
                            getObjectData={getObjectData}
                            orderByItemsCount={orderByItemsCount}
                        />
                    )}

                    {shippingMethods && (
                        <FormToggleSelection
                            data={shippingMethods}
                            title={<FormattedMessage id={"wms.newPickingMission.shippingMethods"}/>}
                            identity={"name"}
                            count={"count"}
                            icon={"logo"}
                            handleSelectValue={handleSelectShippingMethods}
                            isModel={isModel}
                            getObjectData={getObjectData}
                            orderByItemsCount={orderByItemsCount}
                        />
                    )}

                    {!isMobile && openProviderDrawer && providers && (
                        <DesktopProviderDrawer
                            open={openProviderDrawer}
                            handleClose={handleCloseProviderDrawer}
                            providers={providers}
                            handleSelectProvider={handleSelectProvider}
                            isModel={isModel}
                        />
                    )}

                    {isMobile && openProviderDrawer && providers && (
                        <MobileProviderDrawer
                            open={openProviderDrawer}
                            handleClose={handleCloseProviderDrawer}
                            providers={providers}
                            handleSelectProvider={handleSelectProvider}
                            isModel={isModel}
                        />
                    )}

                    {selectedProviders && (
                        <FormToggleSelection
                            data={selectedProviders}
                            title={<FormattedMessage id={"wms.newPickingMission.providers"}/>}
                            identity={"name"}
                            count={"count"}
                            handleSelectValue={handleDeselectProvider}
                            isNotFinal
                            handleAddValue={handleOpenProviderDrawer}
                            isModel={isModel}
                            getObjectData={getObjectData}
                            orderByItemsCount={orderByItemsCount}
                        />
                    )}

                    {ages && (
                        <FormToggleSelection
                            data={ages}
                            title={<FormattedMessage id={"wms.newPickingMission.age"}/>}
                            identity={"name"}
                            count={"count"}
                            handleSelectValue={handleSelectAge}
                            isModel={isModel}
                            getObjectData={getObjectData}
                        />
                    )}

                    <Grid container direction={"column"} sx={{width: isMobile ? '100%' : desktopMaxWidth}} gap={"8px"}>
                        <span
                            style={{
                                fontWeight: 600,
                                fontSize: "12px"
                            }}
                        >
                            <FormattedMessage id={"wms.newPickingMission.quantity"}/>
                        </span>
                        <TextField
                            type={"number"}
                            inputProps={{ min: 1, step: 1 }}
                            value={quantity}
                            onChange={(event) => handleChangeQuantity(event.target.value)}
                        />
                        {numberProductError && (
                            <span style={{color: red500}}><FormattedMessage id={"wms.newPickingMission.productNumberError"}/></span>
                        )}
                    </Grid>

                    {runners && false === isModel && (
                        <RunnerSelect
                            runners={runners}
                            selectedRunners={selectedRunners}
                            handleSelectRunners={handleSelectRunners}
                            desktopMaxWidth={desktopMaxWidth}
                        />
                    )}
                </Grid>
            </Grid>
            <footer style={{position: "sticky", bottom: 0,}}>
                <Grid container direction={"row"} wrap={"nowrap"} justifyContent={"end"} gap={"16px"}>
                    <CustomButton color={"default"}>
                        <FormattedMessage id={"wms.newPickingMission.cancelButton"}/>
                    </CustomButton>
                    <CustomButton
                        onClick={handleValid}
                        disabled={!isValid || loading}>
                        <span>
                            {isModel ?
                                <FormattedMessage id={"wms.newPickingMission.validButton.missionModel"}/> :
                                <FormattedMessage id={"wms.newPickingMission.validButton"}/>}
                            <br/>
                            ({productCount} <FormattedMessage id={"wms.newPickingMission.productCountLabel"}/>)
                        </span>
                    </CustomButton>
                </Grid>
            </footer>
        </Grid>
    );
}
export default CreatePickingMissionForm;
